import { TemplateConfig } from '../../../template-config.interface';
import { ESPN_ACCORDION_CONFIG } from '../../../shared/accordion-configs';
import { SHARED_ESPN_CONFIG, FUTBOL_TEAMS } from '../shared';

export const disneyEspnFutbol: TemplateConfig = {
  id: 'espn/espn-vs/futbol',
  clientId: 'DISNEY',
  title: 'VS ESPN Fútbol',
  description: 'Template ESPN deportivo',
  aspectRatio: 'vertical',
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/vs_espn.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/vs_espn.png',
  video: '',
  video_1080x1920: 'https://media.backend.doer.ar/brands/Ejemplos/previews/espn_vs/espn-vs_1080x1920.mp4',

  config: {
    renderer: 'accordion',
    accordionConfig: ESPN_ACCORDION_CONFIG
  },

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'team1',
      label: 'Equipo 1',
      type: 'select',
      options: FUTBOL_TEAMS,
      defaultValue: 'river plate',
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team2'],
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/vs-espn/team_1.png'
    },
    {
      key: 'team2',
      label: 'Equipo 2',
      type: 'select',
      options: FUTBOL_TEAMS,
      defaultValue: 'palmeiras',
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team1'],
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/vs-espn/team_2.png'
    },
    {
      key: 'date',
      label: 'Fecha',
      type: 'calendar',
      placeholder: 'YYYY/MM/DD',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/vs-espn/day.png'
    },
    {
      key: 'day',
      label: 'Día',
      type: 'select',
      options: SHARED_ESPN_CONFIG.days,
      defaultValue: 'domingo',
      required: true
    },
    {
      key: 'autoSyncTimes',
      label: 'Sincronizar horarios desde Argentina',
      type: 'switch',
      defaultValue: true,
      required: false
    },
    {
      key: 'region1',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'arg/uru',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/vs-espn/region.png'
    },
    {
      key: 'time1',
      label: 'Hora',
      type: 'time',
      placeholder: '19:00',
      required: true
    },
    {
      key: 'region2',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'cl',
      required: false
    },
    {
      key: 'time2',
      label: 'Hora',
      type: 'time',
      placeholder: '21:00',
      required: false
    },
    {
      key: 'region3',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'col/pe',
      required: false
    },
    {
      key: 'time3',
      label: 'Hora',
      type: 'time',
      placeholder: '23:00',
      required: false
    },
    {
      key: 'enableRegion4',
      label: '',
      type: 'switch',
      defaultValue: false,
      required: false
    },
    {
      key: 'region4',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'mx',
      required: false
    },
    {
      key: 'time4',
      label: 'Hora',
      type: 'time',
      placeholder: '01:00',
      required: false
    },
    {
      key: 'channel',
      label: 'Canal',
      type: 'select',
      options: SHARED_ESPN_CONFIG.channels,
      defaultValue: 'espn y disney+',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/vs-espn/channel.png'
    },
    {
      key: 'tournament',
      label: 'Torneo',
      type: 'select',
      options: [
        { value: 'generico', label: 'Genérico' },
        { value: 'libertadores', label: 'Libertadores' }
      ],
      defaultValue: 'generico',
      required: true
    }
  ],

  promptTemplate: `Haceme un asset de la Copa Libertadores
entre los equipos "River Plate" y "Palmeiras",
con un diseño: "Genérico o Libertadores"`
};
